/**
 * Ermittelt beim Login die Benutzerkennung, deren App-Daten geladen werden.
 *
 * Ohne Mock-Modus ist das IMMER die eigene Kennung aus dem Token; die
 * Benutzerliste der Mock-Kanzlei wird dann gar nicht abgefragt. Früher fragte
 * der Login sie bei jedem Aufruf ab (`getUsers(id: mock_customer_id)`) und
 * nutzte das Ergebnis nur im Mock-Modus. Mit der Mandantenwache im Gateway
 * (POLICY_ENFORCE) ist diese Abfrage für jeden echten Nutzer eine fremde
 * Kanzlei und würde abgewiesen.
 *
 * @param useMock - Mock-Modus aus dem sessionStorage (`useMock`).
 * @param ownUserId - Eigene Benutzerkennung aus dem Token.
 * @param loadMockUserId - Lädt die erste Benutzerkennung der Mock-Kanzlei.
 * @returns Die Benutzerkennung für `getAppUserInfo`.
 */
export async function resolveLoginUserId(
  useMock: unknown,
  ownUserId: string,
  loadMockUserId: () => Promise<string>
): Promise<string> {
  if (!useMock) return ownUserId;
  return loadMockUserId();
}
